import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ResetSpocPasswordRPC } from "./resetSpocPasswordRPC";

export class ResetSpocPasswordRPCClientImpl extends ResetSpocPasswordRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ResetSpocPasswordRPC.Request): Promise<LeoRPCResult<ResetSpocPasswordRPC.Response, ResetSpocPasswordRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "spoc-management/ResetSpocPassword",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ResetSpocPasswordRPC.ResponseDTO,
      ResetSpocPasswordRPC.Errors.ErrorsDTO,
      ResetSpocPasswordRPC.Response,
      ResetSpocPasswordRPC.Errors.Errors
    >(
      response,
      "spoc-management/ResetSpocPassword",
      ResetSpocPasswordRPC.Response.fromDTO,
      ResetSpocPasswordRPC.Errors.fromDTO
    );
  }
}
